import { IStateZipToListVM } from "../interfaces/PostalCodeInterfaces";
import BaseApi from "./BaseApi";

const baseUrl = 'api/zipCode/';

class ZipCodeService {
    static get(zipCode: string): Promise<any> {
        return BaseApi.get(`${baseUrl}${zipCode}`);
    }

    static getState(): Promise<IStateZipToListVM[]> {
        return BaseApi.get(`${baseUrl}state`);
    }

    static getTypesAdress(productId:number): Promise<any> {
        return BaseApi.get(`${baseUrl}address/type/list/${productId}`);
    }
    static getPropertyOwner(): Promise<any> {
        return BaseApi.get(`${baseUrl}property/owner/list`);
    }

    static getCitiesOptions(stateCode: string): Promise<any[]> {
        return BaseApi.get(`${baseUrl}state/${stateCode}/cities`);
    }
}

export default ZipCodeService;